module.exports = __webpack_public_path__ + "images/category_lp/pc/SP_3_400361227c9e02fb3c071777d8c7d034.png";